<template>
  <div class="uni-collapse">
    <el-collapse v-model="activeName" accordion @change="handleChange">
      <el-collapse-item
        class="uni-collapse-item"
        :name="itemF.id"
        v-for="(itemF, index) in activeNamesList"
        :key="index"
      >
        <template slot="title">
          <div class="header">
            <div style="flex: 1">
              <i class="el-icon-arrow-up"></i>
              <i class="iconfont icon123 gray-light"></i>
              <span class="cell-title">{{ itemF.title }}</span>
              <span
                v-if="activeNames == itemF.id"
                style="color: #ff6800; margin-left: 10px"
                >(正在学习)</span
              >
            </div>
            <div class="refresh-box">
              <slot name="title-right">
                <template>
                  <a
                    v-if="itemF.courseware"
                    :href="itemF.courseware"
                    class="online"
                    target="_blank"
                  >
                    <em></em><span>课件下载</span>
                  </a>
                </template>
              </slot>
            </div>
          </div>
        </template>

        <slot name="collapseContent">
          <div class="collapse-cell" v-for="item in itemF.node" :key="item.id">
            <div class="title-box item">
              <span>{{ item.rate | getStudyStatus }}</span>
              <span class="span tit">{{ item.title }}</span>

              <span v-if="item.video_duration" class="span">
                总时长：{{ item.video_duration_format }} 已学习：{{
                  item.rate | getStudyPersent
                }}%
              </span>
              <span class="span" v-else>暂无课程视频，请下载课件学习</span>
            </div>

            <div
              class="item"
              v-if="item.course_type !== 3 && item.task_num > 0"
            >
              <span style="margin-left: 100px">{{
                item.rate | getWorkScore
              }}</span>
            </div>

            <div class="btn-box">
              <span class="span">    
                <el-button
                  v-if="
                    item.course_type === 1 &&
                    item.task_num > 0 &&
                    (item.rate ? item.rate.task_status === 0 : true) &&
                    ((dataObj.is_hours_complete === 1 && (item.rate ? item.rate.learn_status === 1 : false)) || dataObj.is_hours_complete === 0)
                  "
                  plain
                  class="uni-disabled-btn disabled-btn-span"
                  icon="el-icon-edit"
                  @click="goHomework(item)"
                >
                  做作业
                </el-button>
                <span
                  v-else-if="
                    item.course_type === 1 &&
                    item.task_num > 0 &&
                    dataObj.is_hours_complete === 1 &&
                    (item.rate ? item.rate.learn_status === 0 : true)
                  "
                  >未完成学习</span
                >
                <span v-else-if="item.course_type === 1 && item.task_num === 0"
                  >暂无作业</span
                >

                <el-button
                  v-if="
                    item.course_type === 2 &&
                    item.practice_num > 0 &&
                    (item.rate ? item.rate.task_status === 0 : true) &&
                    ((dataObj.is_hours_complete === 1 && (item.rate ? item.rate.learn_status === 1 : false)) || dataObj.is_hours_complete === 0)
                  "
                  plain
                  class="uni-disabled-btn disabled-btn-span"
                  icon="el-icon-edit"
                  @click="goPractice(item)"
                >做练习</el-button>
                <span v-else-if="item.course_type == 2 && item.task_num === 0">暂无练习</span>

                <el-button
                  v-if="item.video_duration && isAllowed == 1"
                  class="uni-link-btn"
                  type="primary"
                  icon="el-icon-video-play"
                  @click="startStudy(item)"
                >
                  {{
                    item.rate
                      ? item.rate.last_node > 0
                        ? "继续学习"
                        : "开始学习"
                      : "开始学习"
                  }}
                </el-button>
              </span>
            </div>
          </div>
        </slot>
      </el-collapse-item>
    </el-collapse>

    <!-- 提示框 -->
    <ComponentDialog1
      icon="fail"
      :title="dialogTitle"
      :visible.sync="isDialogVisible"
      @confirm="isDialogVisible = !isDialogVisible"
      :showCancelBtn="false"
      :confirmText="dialogButtonText"
    />
  </div>
</template>

<script>
import { getHomeWork, getSectionDetail } from "@/api/basic";
export default {
  name: "ComponentCollapse",
  props: {
    name: {
      type: String,
      default: "",
    },
    // 标题
    title: {
      type: String,
      default: "马克思",
    },
    // 数据
    datas: {
      type: Array,
      default: () => [],
    },
    activeNames: {
      type: Number,
      default: 0,
    },
    activeNamesList: {
      type: Array,
      default: () => [],
    },
    dataObj: {
      type: Object,
      default: () => {},
    },
    typeName: {
      type: String,
      default: "",
    },
    isStudyWork: {
      type: Boolean,
      default: true,
    },
    // 是否允许开始学习 0否 1是
    isAllowed: {
      type: Number,
      default: 0,
    },
  },
  filters: {
    getWorkScore(item) {
      if (!item) return "未完成";
      if (item.task_status == undefined) {
        return "未完成";
      } else if (item.task_status == 0) {
        return `总题：${item.work_num}，已做：${item.task_num}，未完成`;
      } else if (item.task_status == 1) {
        return `总题：${item.work_num}，已做：${item.task_num}， 已完成`;
      }
    },
    getStudyStatus(item) {
      if (!item) return "待学习";
      if (item.learn_status == 1) {
        return "已完成";
      } else if (item.long_node > 0) {
        return "学习中";
      } else {
        return "待学习";
      }
    },
    getStudyPersent(item) {
      if (!item) return 0;
      if (item.video_duration && item.video_duration != 0) {
        return parseInt((item.long_node / item.video_duration) * 100);
      } else {
        return 0;
      }
    },
  },
  watch: {
    activeNames(val) {
      this.activeName = val;
    },
  },
  data() {
    return {
      activeName: this.activeNames,
      isDialogVisible: false,
      dialogTitle: "",
      dialogButtonText: "确定",
    };
  },
  methods: {
    handleChange(val) {
      this.activeName = val;
      this.$emit("change", val);
    },
    startStudy(item) {
      const params = {
        course_id: item.course_id,
        section_id: item.id,
      };
      getSectionDetail(params).then((res) => {
        if (res.result) {
          this.$router.push({
            name: "studyNotes",
            query: {
              course_id: item.course_id,
              lession_id: item.id,
            },
          });
        } else {
          this.dialogTitle = res.msg;
          this.isDialogVisible = true;
        }
      });
    },
    // 做作业
    goHomework(item) {
      //查看解析
      if (item.task_score && item.task_score == item.full_marks) {
        this.$router.push({
          name: "practiceAnalysis",
          query: {
            make_id: item.make_id,
            course_id: item.course_id,
          },
        });
        return false;
      }

      // 做作业
      const params = {
        course_id: item.course_id,
        section_id: item.id,
      };
      getHomeWork(params).then((res) => {
        if (res.code == 200) {
          this.$router.push({
            name: "homeWork",
            query: params,
          });
        }
      });
    },
    // 做练习
    goPractice(item) {
      this.$router.push({
        name: "startPractice",
        query: {
          course_id: item.course_id,
          section_id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.uni-collapse {
  .el-collapse-item__header {
    height: 65px;
    line-height: 65px;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
    font-size: 14px;
  }
  .el-collapse-item__arrow {
    display: none;
  }
  .el-collapse-item {
    margin-bottom: 10px;
  }
}
</style>

<style lang="scss" scoped>
.uni-collapse {
  // margin-bottom: 8px;

  .header {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding-left: 40px;
    font-size: 14px;
    font-weight: 500;

    .iconfont {
      vertical-align: middle;
      margin: 0 7px;
      font-size: 40px;
    }

    .refresh-box {
      color: $textGray;
      margin-right: 10px;
      a {
        width: 150px;
      }
      .iconfont {
        font-size: 16px;
      }
    }
  }
  .el-icon-arrow-up {
    transition: all 0.3s;
  }
  .uni-collapse-item {
    &.is-active {
      .el-icon-arrow-up {
        transform: rotate(180deg);
      }
    }
  }
  .collapse-cell {
    display: flex;
    padding: 25px 20px 25px 70px;
    align-items: center;
    border-top: 1px solid #ebebeb;
    // height: 50px;
    background: #f8f9fb;
    // justify-content: space-between;
    color: $grayColor !important;

    .item {
      flex: 1;
    }

    .btn-box {
      width: 300px;
      text-align: right;
    }

    .title-box {
      flex: 2;
      display: flex;
      align-items: center;
    }

    .iconfont {
      vertical-align: middle;
      font-size: 25px;
      margin: 0 8px;
    }

    .tit {
      display: inline-block;
      width: 400px;
      margin-left: 25px;
    }

    &:hover {
      background: #f5fdff;

      .tit {
        @include fontColor("primary");
      }
    }

    .span {
      margin-right: 16px;
    }
  }
  .uni-link-btn {
    @include uni-link-btn;
    margin-left: 40px;
  }

  .uni-disabled-btn {
    min-width: 80px;
    padding: 0px 14px;
    line-height: 22px;
    font-size: 12px;
    @include borderColor("primary");
    @include fontColor("primary");
  }

  .online {
    width: 90px;
    height: 42px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    cursor: pointer;
    font-size: 15px;
    border-bottom: 1px solid transparent;
    span {
      color: #ff6800;
    }
    em {
      width: 23px;
      height: 22px;
      background: url("~@/assets/images/downloadIcon.png") no-repeat;
      background-size: 100% 100%;
      margin-right: 5px;
    }

    &:hover {
      border-bottom: 1px solid #ff6800;
    }
  }
}
</style>
